import api from "./api";

const BASE = "/company-popups";

export const getActivePopups = () => api.get(`${BASE}/active`);
export const dismissPopup = (id) => api.post(`${BASE}/${id}/dismiss`);

export const listPopups = () => api.get(BASE);
export const getPopup = (id) => api.get(`${BASE}/${id}`);
export const createPopup = (data, config) => api.post(BASE, data, config);
export const updatePopup = (id, data, config) => api.put(`${BASE}/${id}`, data, config);
export const deletePopup = (id) => api.delete(`${BASE}/${id}`);
export const resetDismissals = (id) => api.post(`${BASE}/${id}/reset-dismissals`);
export const previewCount = (filters) => api.post(`${BASE}/preview-count`, { filters });
